// Copyright © 2017-2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <div fluid ="padding: 8px;">
    <v-card flat>
      <v-card-text>
        <p class="title">{{ item.info.description }} </p>
        Version: {{ item.info.version }}<br>
        Path: {{ item.host }}{{ item.basePath }}
      </v-card-text>
      <v-expansion-panel expand>
        <template v-for="(path, key, h) in item.paths">
          <v-expansion-panel-content v-for="(verb, verbkey, i) in path" :key="i + (h * 2000)">
            <div slot="header" class="title">
              <v-btn depressed dark :color="httpColor(verbkey)">{{ verbkey }}</v-btn>
              <span class="pr-2" style="display:inline-block;">{{ key }}</span>
              <span class="body-2" style="display:inline-block;">{{ verb.summary }}</span>
            </div>
            <v-card>
              <v-card-text>
                <v-layout row class="subheading" font-weight-bold><v-flex xs12>Parameters</v-flex></v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm3>
                    <span class="font-weight-bold">Name</span>
                  </v-flex>
                  <v-flex xs12 sm9>
                    <span class="font-weight-bold">Description</span>
                  </v-flex>
                </v-layout>

                <v-layout row wrap v-for="(param, i) in verb.parameters" :key="i">
                  <v-flex xs12 sm3>
                    <v-layout column style="margin: 0px;">
                      <span class="font-weight-bold">{{ param.name }}</span>
                      <span class="caption">{{ param.type }} ({{param.format}})</span>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm9>
                    <v-layout column>
                      <span>{{ param.description }}</span>
                      <span class="font-italic">Default value: {{ param.default }}</span>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 style="border-top: 1px solid rgba(0,0,0,.3);"></v-flex>
                </v-layout>

                <v-layout row class="subheading" font-weight-bold><v-flex xs12>Responses</v-flex></v-layout>
                <v-layout row wrap v-for="(resp, key, i) in verb.responses" :key="i + 1000">
                  <v-flex xs12 sm3>
                    {{ key }}
                  </v-flex>
                  <v-flex xs12 sm9>
                    {{ resp.description }}
                  </v-flex>
                  <v-flex xs12>
                    <template v-if="resp.schema">
                      <a @click="scrollMeTo(resp.schema.$ref)" v-if="resp.schema.$ref">{{replaceModelName(resp.schema.$ref)}}</a>
                      <template v-else-if="resp.schema.type == 'array'">
                        <a @click="scrollMeTo(resp.schema.items.$ref)" v-if="resp.schema.items.$ref">
                          [{{ replaceModelName(resp.schema.items.$ref) }}]
                        </a>
                        <span v-else>
                          [{{ resp.schema.items.type }}]
                        </span>
                      </template>
                    </template>
                  </v-flex>
                </v-layout>

              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </template>
      </v-expansion-panel>
      <v-layout row>
        <v-flex xs12>
          <v-card class="elevation-0">
            <v-card-text>
              <span class="display-1" font-weight-bold>Models:</span>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-expansion-panel expand>
        <template v-for="(model, modelkey) in item.definitions">
          <v-expansion-panel-content :key="modelkey">
            <div slot="header" class="title" :ref="'model_' + modelkey">{{ modelkey }}</div>
            <v-card>
              <v-card-text>
                <v-layout row class="subheading" font-weight-bold><v-flex xs12>Parameters</v-flex></v-layout>
                <model :model=model.properties></model>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </template>
      </v-expansion-panel>
    </v-card>
  </div>
</template>

<script>
import Model from '@/components/Model'

export default {
  components: {
    Model
  },

  props: {
    // v-model input
    value: Object
  },

  data () {
    return {
      item: this.value
    }
  },

  watch: {
    value (val) {
      this.item = this.value
    }
  },

  methods: {
    httpColor: function (term) {
      if (term === 'get') {
        return 'primary'
      } else if (term === 'patch') {
        return 'green lighten-2'
      } else if (term === 'put') {
        return 'orange'
      } else if (term === 'post') {
        return 'green'
      } else {
        return 'error'
      }
    },

    replaceModelName: function (name) {
      var split = name.split('/')
      return 'Model: ' + split[split.length - 1]
    },

    scrollMeTo (refName) {
      if (typeof refName === 'string') {
        var split = refName.split('/')
        var dest = split[split.length - 1]

        var element = this.$refs['model_' + dest]
        var top = element[0].offsetParent.offsetTop
        window.scrollTo(0, top)
      } else {
        console.log('scroll error: ' + refName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OpenApi.vue